import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type SlurryDetailsTab = 'info' | 'props' | 'foam' | 'other' | 'mixability' | 'redesign' | 'batches';

@Component({
  selector: 'app-slurry-tabs-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slurry-tabs-nav.component.html'
})
export class SlurryTabsNavComponent {
  @Input({ required: true }) activeTab: SlurryDetailsTab = 'info';
  @Input() hasSavedSlurry = false;
  @Input() showPropsTab = false;
  @Input() showFoamTab = false;
  @Input() showOtherTab = false;
  @Input() showMixabilityTab = false;
  @Input() showRedesignTab = false;
  @Input() showBatchesTab = false;

  @Output() tabSelected = new EventEmitter<SlurryDetailsTab>();
}
